import React from 'react';
import SelfLearninga from 'views/SelfLearning'

const SelfLearning = () => {
  return <SelfLearninga />;
};

export default SelfLearning;